import { render, staticRenderFns } from "./PrivatePensionSection.vue?vue&type=template&id=164821e6&scoped=true&"
import script from "./PrivatePensionSection.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PrivatePensionSection.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PrivatePensionSection.vue?vue&type=style&index=0&id=164821e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164821e6",
  null
  
)

export default component.exports